<template>
    <div class="device-type-manange relative">
        <div class="buttons">
            <el-button :id="'doctorAdd'" @click="addData">新增</el-button>
        </div>

        <div class="docker_buttons">
            <el-button type="primary" :id="'doctorDownload'" @click="exportExcel">导出数据</el-button>
        </div>

        <el-table ref="multipleTable"
                  :data="tableData"
                  border
                  style="width: 100%">
<!--            <el-table-column prop="sort" label="排序" align="center" label-class-name="label"></el-table-column>-->
            <el-table-column prop="no" label="序号" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="catalog_name" label="分类名称" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="bloc_number" label="集团数量" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="update_date" label="更新时间" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="status" label="状态" align="center" label-class-name="label"></el-table-column>
            <el-table-column
                    prop="address"
                    label="操作"
                    align="center"
                    label-class-name="label"
                    v-slot="scope"
            >
                <el-button :id="'doctorEdit'" @click="goEdit(scope.row)"
                           type="text" size="mini">编辑
                </el-button>
                <el-button :id="'doctorEdit'" @click="deleteData(scope.row)"
                           type="text" size="mini">删除
                </el-button>
                <el-button :id="'upDownArticle'" @click="startStopTitle(scope.row,2)"
                           v-if="scope.row.status_number==1"
                           type="text"
                           size="small">停用
                </el-button>
                <el-button :id="'upDownArticle'" @click="startStopTitle(scope.row,1)"
                           v-if="scope.row.status_number==2"
                           type="text"
                           size="small">启用
                </el-button>
                <el-button :id="'doctorEdit'" @click="getBloc(scope.row)"
                           type="text" size="mini">集团
                </el-button>
                <el-button :id="'doctorEdit'" @click="addBloc(scope.row)"
                           type="text" size="mini">添加集团
                </el-button>
            </el-table-column>
        </el-table>
        <el-pagination
                class="mg-20 ta-r"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 25, 50, 100]"
                :total="total"
                :page-size="perpage"
                :current-page="page"
                @current-change="changePage"
                @size-change="changeSite"
        ></el-pagination>
    </div>
</template>
<script>
    import {export2Excel} from "@/utils/excel";
    import env from "@/api/env";
    import {check} from "@/utils/checkData";

    export default {
        data() {
            return {
                page: 1,
                perpage: 10,
                total: 0,
                tableData: [],
                is_submit: false,
            };
        },
        created() {

        },
        mounted() {
            // 获取分类列表
            this.getList();
            localStorage.setItem('prev_page', 'catalog_list')
        },
        methods: {
            // 获取所有医生
            getList() {
                let params = {
                    servername: 'Ruyi_AdminOperateServices',
                    method: 'blocCatalogListing',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    for (var i = 0; i < res.data.data.list.length; i++) {
                      // 序号
                      res.data.data.list[i].no = (this.page - 1) * this.perpage + i + 1
                        switch (res.data.data.list[i].status) {
                            case '1':
                                res.data.data.list[i].status = '启用';
                                res.data.data.list[i].status_number = 1;
                                break;
                            case '2':
                                res.data.data.list[i].status = '停用';
                                res.data.data.list[i].status_number = 2;
                                break;
                        }
                    }
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.page.count;
                });
            },

            // 改变每页条数
            changeSite(index) {
                this.perpage = index;
                this.getList();
            },

            //更换页码
            changePage(index) {
                this.page = index;
                this.getList();
            },

            // 编辑
            goEdit(data) {
                this.$router.push({
                    name: "catalogEdit", params: {
                        id: data.id,
                        catalog_name: data.catalog_name,
                        sort: data.sort,
                        status: parseInt(data.status_number),
                    }
                });
            },

            // 新增公司
            addData() {
                this.$router.push({name: "catalogAdd", params: {}});
            },

            deleteData(data) {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                this.$confirm('确定删除该集团分类吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        servername: 'Ruyi_AdminOperateServices',
                        method: 'deleteBlocCatalog',
                        params: {
                            id: data.id,
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            this.is_submit = false;
                            return;
                        }
                        if (res.data.code != '0') {
                            this.$message({
                                type: "error",
                                message: res.data.msg,
                                duration: 1500,
                            });
                        } else {
                            this.$message({
                                type: "success",
                                message: '删除成功',
                                duration: 1500,
                            });
                        }
                        this.is_submit = false;
                        this.getList();
                    }).catch(() => {
                        this.is_submit = false;
                    }).finally(() => {
                        this.is_submit = false;
                    });
                }).catch(() => {
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            },

            // 启用停用公司
            startStopTitle(data, status) {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                if (status == '1') {
                    var message = '确定启用该集团分类吗？';
                }
                if (status == '2') {
                    var message = '确定停用该集团分类吗？';
                }
                this.$confirm(message, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        servername: 'Ruyi_AdminOperateServices',
                        method: 'startStopCatalog',
                        pageinfo: {
                            page: this.page,
                            perpage: this.perpage,
                        },
                        params: {
                            id: data.id,
                            status: status
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            this.is_submit = false;
                            return;
                        }
                        this.$message({
                            type: "success",
                            message: '修改成功',
                            duration: 1500,
                        });
                        this.getList();
                        this.is_submit = false;
                    }).catch(() => {
                        this.is_submit = false;
                    });
                }).catch(() => {
                    this.is_submit = false;
                });
            },

            getBloc(data){
                this.$router.push({
                    name: "blocList", params: {
                        catalog_id: data.id
                    }
                });
            },

            addBloc(data) {
                this.$router.push({
                    name: "blocAdd", params: {
                        catalog_id: data.id
                    }
                });
            },

            // 导出数据
            exportExcel() {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                let params = {
                    servername: 'Ruyi_AdminOperateServices',
                    method: 'exportDoctorTitle',
                    params: {
                        title_name: this.title_name,
                        status: this.status,
                    },
                };
                let colums_list = [
                    {title: "ID", key: "id"},
                    {title: "职称名称", key: "title_name"},
                    {title: "特属专家数量", key: "doctor_number"},
                    {title: "更新时间", key: "update_date"},
                    {title: "状态", key: "status"},
                ];
                let export_data = [];
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }

                    let res_data = res.data;
                    if (parseInt(res_data.code) != 0) {
                        this.$message.error(res_data.msg);
                        this.is_submit = false;
                        return false;
                    }

                    for (let i = 0; i < res_data.data.length; i++) {
                        let status;
                        switch (res_data.data[i].status) {
                            case '1':
                                status = '启用';
                                break;
                            case '2':
                                status = '停用';
                                break;
                        }

                        let item = {
                            id: res_data.data[i].id,
                            title_name: res_data.data[i].title_name,
                            doctor_number: res_data.data[i].doctor_number,
                            update_date: res_data.data[i].update_date,
                            status: status,
                        };
                        export_data.push(item);
                    }
                    export2Excel(colums_list, export_data, "导出职称");
                    let _that = this
                    setTimeout(function () {
                        _that.is_submit = false;
                    }, 1500)
                });
            }


        }
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .docker_buttons {
        float: right;
        margin: 30px 0px 8px 0px;

        .el-button {
            width: 150px;
            height: 32px;
            line-height: 7px;
        }
    }
</style>
